// extracted by mini-css-extract-plugin
export default {"imageWrapper":"gK-z","twoColumnImage":"hK-z"};